<template>
<div>
  <div id='staff'>
  <el-dialog
    width="1200px"
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    class="default-dialog"
  >
    <div class="title">员工信息</div>
    <div style="margin-bottom: 30px">
      <div>
        <span style="margin-right:2px;color:red;" >*</span>是否在职
         <el-radio-group v-model="status" style="margin-left:26px;" @input="statusChange" :disabled="row.status == 2">
          <el-radio :label="1">在职</el-radio>
          <el-radio :label="2">离职</el-radio>
         </el-radio-group>
      </div>
      <div class="acc_flex staff_box">
        <template v-for="(item, i) in staff_info">
          <div class="staff_item" :key="i" v-if="item.show!=false" >
            <span v-if="item.must" style="margin-right:2px;color:red;" >*</span>{{ item.label }}
          </div>
          <div :key="item.label" class="staff_value" v-if="item.show!=false" :class="{'bz':item.label=='备注','error':item.valid=='error'}" :title="item.errorTip">
            <el-radio-group v-model="item.value" v-if="item.field=='gender'" @change="validChange($event,item,i)">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
            <el-select v-model="item.value" placeholder="请选择" v-else-if="['cardType','education','deptName','subjectId'].indexOf(item.field)>-1" size="mini" @change="validChange($event,item,i)" clearable  :filterable="item.field=='subjectId'?true:false"  :popper-append-to-body="false" :class="{'showAdd':['deptName','subjectId'].indexOf(item.field)>-1?true:false}">
              <el-option
                v-for="(op,i) in item.list"
                :key="i"
                :label="op.name||op.label"
                :value="item.field=='deptName'?op.name:op.id||op.value">
              </el-option>
               <template v-if="item.field=='subjectId'">
                  <div class="addKM" @click.stop="newModalOpen">+新增科目</div>
               </template>
                <template v-if="item.field=='deptName'">
                  <div class="addKM" @click.stop="addDep">+新增部门</div>
               </template>
               <template #empty>
                <div style="padding:20px 0;">
                    <div class="addKM" @click.stop="newModalOpen" v-if="item.field=='subjectId'">+新增科目</div>
                    <div class="addKM" @click.stop="addDep" v-if="item.field=='deptName'">+新增部门</div>
                </div>

               </template>
            </el-select>
             <el-date-picker   value-format="yyyy-MM-dd" v-model="item.value" size="mini" type="date" placeholder="选择日期" v-else-if="['entryDate','salaryStartDate','dimissionDate','salaryEndDate'].indexOf(item.field)>-1" clearable @change="validChange($event,item,i)" :disabled="row.status == 2&&['entryDate','salaryStartDate'].indexOf(item.field)>-1"></el-date-picker >
            <input v-else type="text" v-model.trim="item.value" style="border:0;outline:none;" @blur="validChange(null,item,i)">
            <div class="errorTip">{{item.errorTip}}</div>
          </div>
        </template>
      </div>
    </div>
    <div>
      <div>
        <span style="margin-right:2px;color:red;" >*</span>是否缴纳五险一金
        <el-radio-group v-model="payfiveOne" style="margin-left:26px;" @change="project" :disabled="row.status == 2">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
         </el-radio-group>
      </div>
      <publicTable :table="tableData" style="margin-top:20px;" v-if="payfiveOne">
        <!-- 基数-->
        <template #baseMoney="{scope}">
           <el-input v-model="scope.row.baseMoney" @blur="changeMoney(scope.row)"  :disabled="row.status == 2"></el-input>
        </template>
        <!-- 公司比例 -->
         <template #companyPayRatio="{scope}">
           <el-input v-model="scope.row.companyPayRatio"  @blur="changeMoney(scope.row)"  :disabled="row.status == 2" ></el-input>
        </template>
        <!-- 公司金额 -->
        <template #companyPayMoney="{scope}">
           <el-input v-model="scope.row.companyPayMoney" :disabled="scope.row.companyPayRatio==0 || row.status == 2" @blur="markRed(scope.row)" :class="{'markRed':scope.row.markC}" ></el-input>
        </template>
         <!-- 个人比例 -->
         <template #personalPayRatio="{scope}">
           <el-input  v-model="scope.row.personalPayRatio" @blur="changeMoney(scope.row)" :disabled="scope.row.name=='生育保险'||scope.row.name=='工伤保险' || row.status == 2"></el-input>
        </template>
        <!-- 个人金额 -->
        <template #personalPayMoney="{scope}">
           <el-input v-model="scope.row.personalPayMoney" :disabled="scope.row.personalPayRatio==0||scope.row.name=='生育保险'||scope.row.name=='工伤保险' || row.status == 2" @blur="markRed(scope.row)" :class="{'markRed':scope.row.markP}"></el-input>
        </template>
      </publicTable>
    </div>
    <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="submit">确定</el-button>
    </div>

  </el-dialog>
  </div>
   <!-- 科目弹出层-->
    <subject-dialog
      :subParent="false"
       v-if="sub_dialog"
      :show="sub_dialog"
      :subjectData="formDatas"
      @on-close-modal="cancel"
      @add-success-subject="addSuccessCallback"
    ></subject-dialog>
    		<!-- 弹窗框 -->
		<el-dialog
			title="新增部门"
			:visible.sync="dep_dialog" width="420px" :close-on-click-modal="false"
			@close ="depClose"
			class='default-dialog'
		>
			<div class="form-item-public" v-loading="dep_loading">
				<el-form label-width="70px" :model="diaFormData" ref="diaFormData" :rules="diaFormDataRuler">
					<el-form-item label="编码:" required prop="code">
						<el-input v-model="diaFormData.code" size="small" placeholder="请输入编码!"></el-input>
					</el-form-item>
					<el-form-item label="名称:" required prop="name">
						<el-input v-model="diaFormData.name" size="small" placeholder="请输入名称!"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right" v-show="!dep_loading">
				<el-button size="small" @click="dep_dialog=false">取消</el-button>
				<el-button size="small" class='minButton' @click="addAuxilAccount">确定</el-button>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import publicTable from "@/components/publicTable";
import subjectDialog from "@/components/dialog/subjectDialog";
import {findProjectForEmployee,saveEmployee,findWorkCode} from '@/api/index.js'
export default {
  components:{
    subjectDialog,
    publicTable
  },
  data() {
    return {
      row:{
        status:""
      },
      diaFormDataRuler:{
				code:[{required:true,message:'编码必填!'}],
				name:[{required:true,message:'名字必填!'}],
			},
      diaFormData:{
				code:'',
				name:'',
			},
      dep_loading:false,
      dep_dialog:false,
      formDatas: {
        methods: "add",
        type: "资产",
        creditDirection: "借",
      },
      sub_dialog:false,
      rowId:'',
      tableData:{
            border: true, // 是否带有纵向边框
            stripe: true, // 是否带有斑马纹
            loading: false, // 是否显示加载动画
            hasSelect: false, // 是否显示多选
            hasOperation: false, // 是否有操作功能
            hasContextmenu: false, // 是否有右键功能
            hasShowSummary: false, // 是否显示合计行
            hasShowPagination: false, // 是否显示分页
            data:[
            ],
            center: {
            textAlign: "center",
            padding: "6px 0",
            },
            config:[
              {
                label:'项目',
                value:'name',
                show:'normal'
              },
              {
                label:'缴纳基数',
                show:'template',
                value:"baseMoney",
              },
              {
                label:'公司承担部分',
                show:'normal',
                showChild:true,
                children:[
                  {
                    label:'比例%',
                    show:'template',
                    value:'companyPayRatio'
                  },
                  {
                    label:'金额',
                    show:'template',
                    value:'companyPayMoney'
                  }
                ]
              },
              {
                label:'个人承担部分',
                show:'normal',
                showChild:true,
                children:[
                  {
                    label:'比例%',
                    show:'template',
                    value:'personalPayRatio'
                  },
                  {
                    label:'金额',
                    show:'template',
                    value:'personalPayMoney'
                  }
                ]
              }
            ],
      },
      payfiveOne:'',
      status:1,
      staff_info: [
        {
          label: "工号",
          must: true,
          field: "workCode",
          value: "",
          errorTip:"",
          valid:"",
        },
        {
          label: "姓名",
          must: true,
          field: "name",
          value: "",
        },
        {
          label: "性别",
          must: true,
          field: "gender",
          value: "",
        },
        {
          label: "证件类型",
          list:[{label:'居民身份证',value:'1'},
          {label:'港澳居民来往内地通行证',value:'2'},
          {label:'中华人民共和国港澳居民居住证',value:'3'},
          {label:'台湾居民来往大陆通行证',value:'4'},
          {label:'中华人民共和国台湾居民居住证',value:'5'},
          {label:'中国护照',value:'6'},
          {label:'外国护照',value:'7'},
          {label:'外国人永久居留身份证（外国人永久居留证）',value:'8'},
          {label:'中华人民共和国外国人工作许可证（A类）',value:'9'},
          {label:'中华人民共和国外国人工作许可证（B类）',value:'10'},
          {label:'中华人民共和国外国人工作许可证（C类）',value:'11'},
          {label:'其他个人证件',value:'12'}],
          must: true,
          field: "cardType",
          value: "",
        },
        {
          label: "证件号码",
          must: true,
          field: "cardNo",
          value: "",
            valid:'',
          errorTip:"",
        },
        {
          label: "手机",
          field: "phone",
            must: true,
          valid:'',
          errorTip:"",
          value: "",
        },
        {
          label: "邮箱",
          field: "email",
          value: "",
        },
        {
          label: "学历",
          list:[{label:'研究生',value:"6"},{label:'大学本科',value:"5"},{label:"大学本科以下",value:"4"}],
          field: "education",
          value: "",
        },
        {
          label: "银行名称",
          field: "bankName",
          value: "",
        },
        {
          label: "银行账号",
          field: "bankAccount",
          value: "",
        },
        {
          label: "入职时间",
          must: true,
          field: "entryDate",
          value: "",
        },
        {
          label: "部门",
          must: false,
          list:[],
          field: "deptName",
          value: "",
        },
        {
          label: "岗位",
          field: "position",
          value: "",
        },
        {
          label: "工资始发日期",
          must: true,
          field: "salaryStartDate",
          value: "",
        },
        {
          label: "职称",
          field: "jobTitle",
          value: "",
        },
        {
          label: "计提工资科目",
          field: "subjectId",
          list:[],
          value: "",
        },
        {
          label: "离职时间",
          must: true,
          show: false,
          field: "dimissionDate",
          value: "",
        },
        {
          label: "工资停发日期",
          must: true,
          show: false,
          field: "salaryEndDate",
          value: "",
        },
         {
          label: "备注",
          field: "remarks",
          value: "",
          valid:""
        },
      ],
      departmentList:[],
      subjectList:[],
      validKey:true,
      visible: false,
      vaildTable:false,
      auxiliaryAccountingId:'',
    };
  },
  methods: {
    depClose(){
      this.diaFormData = {
				code:'',
				name:'',
			}
      this.dep_dialog = false
    },
    //查询辅助类别
		findAllOject(){
			const _=this;
			let datas = {
			}
			_.$http.post('auxiliaryAccounting/allAccounting',datas).then((res)=>{
				if(res && res.data.code == '1'){
           let deps = res.data.data.find(e=>e.name=='部门')
            _.auxiliaryAccountingId = deps?deps.id:''
				}
			})
		},
    addDep(){
      this.dep_dialog = true
    },
    addAuxilAccount(){
      this.$refs.diaFormData.validate((valid)=>{
        if(valid){
          this.dep_loading = true
          this.diaFormData.auxiliaryAccountingId= this.auxiliaryAccountingId;
					this.$http.post('auxiliaryAccounting/addContent',this.diaFormData).then((res)=>{
						this.dep_loading = false;
						if(res && res.data.code == '1'){
							this.$message({
								message:res.data.msg,
								type:'success'
							});
              this.dep_dialog = false
              this.findDepartment()
						}
					});
        }
      })
    },
     //新增成功科目后进行新的赋值
    addSuccessCallback(val) {
      const _ = this;
      //刷新科目列表数据
      this.sub_dialog = false
       this.findObject()
    },
    cancel() {
      this.sub_dialog = false;
      //刷新科目列表数据
      this.findObject()
    },
    newModalOpen() {
      const _ = this;
      _.sub_dialog = true;
      // _.$refs.selectRef.blur();
      _.formDatas = {
        methods: "add",
        type: "资产",
        creditDirection: "借",
      };
    }, //查询辅助核算
    //金额标红
    markRed(row){
      let companyPayMoney = Number(row.companyPayMoney)
      let personalPayMoney = Number(row.personalPayMoney)
      if(companyPayMoney!=(Number(row.baseMoney)*Number((row.companyPayRatio/100))).toFixed(2)){
        this.$set(row,'markC',true)
      }else {
        this.$set(row,'markC',false)
      }
      if(personalPayMoney!=(Number(row.baseMoney)*Number((row.personalPayRatio/100))).toFixed(2)){
        this.$set(row,'markP',true)
      }else {
         this.$set(row,'markP',false)
      }
      console.log(row)
    },
    changeMoney(row){
      let companyPayRatio = Number(row.companyPayRatio)
      let personalPayRatio = Number(row.personalPayRatio)
      let reg = /^(\d{1,2}(?:\.\d{0,2})?|100(?:\.0{1,2})?)$/
      if(!reg.test(companyPayRatio)||!reg.test(personalPayRatio)){
        this.$message.error('公司比例和个人比例值为0-100,保留两位小数')
      }
      row.companyPayMoney = (Number(row.baseMoney)*Number((row.companyPayRatio/100))).toFixed(2)
      row.personalPayMoney = (Number(row.baseMoney)*Number((row.personalPayRatio/100))).toFixed(2)
    },
    //查询工号
    queryWorkCode(){
      findWorkCode().then(res=>{
        if(res.data.code==1){
          this.staff_info[0].value = res.data.msg
          console.log(res.data.msg)
        }
      })
    },
    project(val){
      if(val&&this.tableData.data.length==0){
         this.queryEmployee()
      }
    },
    //获取保险
    queryEmployee(){
      findProjectForEmployee().then(res=>{
        if(res.data.code==1){
          console.log(res.data.data)
          this.tableData.data = res.data.data
        }
      })
    },
    //获取部门
    findDepartment(){
      this.$http.post('fixed/getauxiliaryAccounting',{}).then(res=>{
          if (res && res.data.code == "1") {
            this.staff_info.forEach((e,i)=>{
              this.departmentList = res.data.data
              if(e.field=='deptName'){
                this.$set(e,'list',res.data.data)
              }
            })
          }
				})
    },
    //获取科目
    findObject(){
       this.$http.post("subject/getAllSujectByContent", {}).then((res) => {
        if (res && res.data.code == "1") {
          this.staff_info.forEach((e,i)=>{
            this.subjectList= res.data.data
              if(e.field=='subjectId'){
                this.$set(e,'list',res.data.data)
              }
          })
        }
      });
    },
    //根据身份证号识别性别
    getGenderByIdNumber(idNumber) {
      const lastDigit = idNumber.substr(-1, 1);
      const parsedIntLastDigit = parseInt(lastDigit, 10);
      if (parsedIntLastDigit % 2 === 0) {
        return 2;
      }
      return 1;
    },
    validChange(e,val,i){
      let phone = /^1[3456789]\d{9}$/; //手机号
      let email = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/; //邮箱
      let cardNo = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dxX]$/;
      let workCode = /^[0-9]*$/;
      console.log(val,111)
      if(val.must&&!val.value){
          if(['entryDate','salaryStartDate','dimissionDate','salaryEndDate','deptName'].indexOf(val.field)>-1){
              this.staff_info[i].errorTip=`请选择${val.label}`
          }else {
              this.staff_info[i].errorTip=`请输入${val.label}`
          }
          this.staff_info[i].valid='error'
          this.$forceUpdate()
          return
      }
      if(val.field=='workCode'&&val.value){
        if(!(workCode.test(val.value))){
              this.staff_info[i].errorTip='请输入数字'
             this.staff_info[i].valid='error'
             this.$forceUpdate()
             return
        }
      }
      if(val.field=='cardNo'&&val.value){
        if(!(cardNo.test(val.value))){
          this.staff_info[i].errorTip='证件号码格式不正确'
          this.staff_info[i].valid='error'
          this.$forceUpdate()
          return
        }else {
          const item = this.staff_info.find(x=>x.field == 'gender')
          if(item){
            item.value = this.getGenderByIdNumber(val.value)
          }
        }
      }
      if(val.field=='phone'&&val.value){
          if(!(phone.test(val.value))){
             this.staff_info[i].errorTip='手机号码格式不正确'
             this.staff_info[i].valid='error'
             this.$forceUpdate()
             return
          }
      }
      if(val.field=='email'&&val.value){
         if(!(email.test(val.value))){
             this.staff_info[i].errorTip='邮箱格式不正确'
             this.staff_info[i].valid='error'
             this.$forceUpdate()
             return
         }
      }
      if(val.field=="bankName"&&val.value){
         if(val.value.length>50){
             this.staff_info[i].errorTip='50个字符以内'
             this.staff_info[i].valid='error'
             this.$forceUpdate()
             return
         }
      }
      if((val.field=='bankAccount'||val.field=='position')&&val.value){
          if(val.value.length>20){
             this.staff_info[i].errorTip='20个字符以内'
             this.staff_info[i].valid='error'
             this.$forceUpdate()
             return
         }
      }
      this.staff_info[i].valid=''
      this.staff_info[i].errorTip=''
      this.$forceUpdate()
    },
    statusChange(val){
        this.staff_info.filter(e=>{
            if(val==2&&'show' in e){
               e.show = true
            }
            if(val==1&&'show' in e){
               e.show = false
            }
            e.valid=''
            e.errorTip=''
        })
      console.log(val,this.staff_info)
    },
    submit() {
      let arr = this.staff_info.filter(e=>e.show!=false)
      arr.forEach((e,i)=>this.validChange(null,e,i))
      const key = arr.every(e=>e.valid=='')
      if(this.payfiveOne===''){
        this.$message.error('请选择是否缴纳五险一金')
        return
      }
      if(key){
        let params = {}
        let list = this.payfiveOne?this.$lodash.cloneDeep(this.tableData.data):[]
        for(let i in this.staff_info){
            if((this.staff_info[i].field=='dimissionDate'||this.staff_info[i].field=='salaryEndDate')&&this.status==1){
                  params[this.staff_info[i].field]=''
            }else {
              params[this.staff_info[i].field] = this.staff_info[i].value
            }
        }
        params.status = this.status
        params.payfiveOne = this.payfiveOne
        if(list.length){
          list = list.map(e=> {
             e.companyPayMoney = e.companyPayMoney?Number(e.companyPayMoney).toFixed(2):e.companyPayMoney
             e.personalPayMoney = e.personalPayMoney?Number(e.personalPayMoney).toFixed(2):e.personalPayMoney
             delete e.markC
             delete e.markP
             delete e.uuid
             return e
          })
        }
       let reg = /^(\d{1,2}(?:\.\d{0,2})?|100(?:\.0{1,2})?)$/
        let valueKey = list.some(e=>{
           if(e.name!='工伤保险'&&e.name!='生育保险'){
            return !reg.test(e.companyPayRatio)||!reg.test(e.personalPayRatio)
           }
        }
        )
        if(valueKey){
          this.$message.error('公司比例和个人比例值为0-100,保留两位小数')
          return
        }
        params.projectList = list
        if(this.rowId) params.id = this.rowId
        let deptName = this.departmentList.find(e=>e.name == params.deptName)
        let subjectName = this.subjectList.find(e=>e.id==params.subjectId)
        params.deptName =  params.deptName||deptName?deptName.name:''
        params.subjectName = subjectName?subjectName.name:''
        saveEmployee(params).then(res=>{
           if(res.data.code==1){
              this.$message.success(res.data.msg)
              this.visible = false
              this.$emit('refsh')
           }
        })
      }
    },
    openTask(type, row) {
      this.row = row ||{status:""}
      this.visible = true;
      this.findObject()
      this.findAllOject()
      this.findDepartment()
      this.$nextTick(()=>{
        this.statusChange(this.status)
      })
      if (type == "add") {
        this.queryEmployee()
        this.queryWorkCode()
        this.rowId = ''
        this.status = 1
        this.staff_info.forEach(e=>{
          e.valid=''
          e.errorTip=''
          e.value=''
        })
        this.staff_info[3].value = '1'
        this.payfiveOne=''
      } else {
        this.rowId = row.id
        this.staff_info.forEach(e=>{
           e.valid=''
          e.errorTip=''
          for(let i in row){
            if(e.field==i){
              if(['entryDate','salaryStartDate','dimissionDate','salaryEndDate'].indexOf(i)>-1){
                e.value = row[i]?this.$formart(row[i],'yyyy-MM-dd'):""
              }else{
                e.value = row[i]||null
              }
            }
          }
        })
        console.log(this.staff_info)
        this.payfiveOne = row.payfiveOne
        this.status = row.status||1
        this.tableData.data = row.projectList
        if(this.tableData.data.length){
          this.tableData.data.forEach(e=>{
            this.markRed(e)
        })
        }
      }
    },
  },
};
</script>
<style lang='less'>

</style>
<style lang="less" scoped>
 .showAdd {
  /deep/ .el-select-dropdown__list {
    padding-bottom: 31px !important;
  }
  .addKM {
    position: absolute;
    bottom: 0;
    padding: 5px 16px;
    background-color: #eee;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      color: #3a8ee6;
    }
  }
}
.markRed {
  /deep/ .el-input__inner {
   color: red !important;
  }
}
.error {
  // border: 1px solid #F56C6C !important;
}
.bz {
  flex: 1;
  border-right: 0 !important;
  box-sizing: border-box;
  justify-content: flex-start !important;
}
.staff_box {
  margin-top: 20px;
  flex-wrap: wrap;
  box-sizing: border-box;
  border: 1px solid #E9E9E9;
  border-bottom: 0;
}
.staff_value {
  position: relative;
  display: flex;
  // flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 190px;
  height:40px;
  box-sizing: border-box;
  padding: 10px;
  transition: all .3s;
  border-top: 1px solid transparent;
  border-left: 1px solid #E9E9E9;
  border-right: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9;
  .errorTip {
    position: absolute;
    font-size: 12px !important;
    color: red;
    bottom: -4px;
    transition: all .2s;
    left: 4px;
    z-index: 10;
  }
  &:nth-child(3n){
    border-right: 1px solid transparent;
  }
  .error_tip {
    font-size: 12px;
    width: 100%;
    text-align: left;
    color: #F56C6C;
  }
}
.staff_item {
  padding: 10px;
  max-height: 50px;
  border-bottom: 1px solid #E9E9E9;
  height:40px;
  box-sizing: border-box;
  background: #F7F7F7;
  text-align: right;
  font-weight: 600;
  color: #4A4A4A;
  width: 189px;
}
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269d7b;
  }
}
#staff {
  /deep/ .el-input__inner {
  border: 0 !important;
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none !important;
}
/deep/ .el-dialog__body {
  padding: 40px 30px !important;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/salary/components/UpdateStaff.vue